import axios from 'axios';
import { DATAMASTER_ENDPOINT } from 'common/endpoints';

export async function uploadExcelPrices(file){
  try {
    const excelFormData = new FormData()
    excelFormData.append('file', file)
    const response = await axios.post(`${DATAMASTER_ENDPOINT}/processDatamasterPrices`,excelFormData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      }
    })
    return response.data
  } catch (error) {
    throw(error.response.data.message)
  }
}